<div class="contact-info" x-ms-format-detection="none">
  <div class="app-contact-title">Unsere Service - Hotline</div>
  <div class="description">Bei Fragen zu dem EnergiePortal oder technischen Störungen im Netzbetrieb unterstützen Sie unsere Service-Teams.</div>
  <div class="app-contact-info">
    <div class="left-part" *ngIf="showContactDetails">
      <div class="label">EnergiePortal</div>
      <a href="tel:{{ 'module.contact.telephoneTel' | translate }}" class="number">{{ 'module.contact.telephoneText' | translate }}</a>
      <div class="email" (click)="mailer()">{{ 'module.contact.email' | translate }}</div>
      <div class="separator"></div>
      <div class="operating-hours">
        <div class="operating-hrs-label">
          <div>Mo - Do:</div>
          <div>Fr:</div>
        </div>
        <div>
          <div>{{ 'module.contact.weekdaysText' | translate }}</div>
          <div>{{ 'module.contact.weekendsText' | translate }}</div>
        </div>
      </div>
    </div>
    <div class="right-part">
      <div class="label">{{ 'module.contact.faultNumberPowerText' | translate }}</div>
      <a href="tel:{{ 'module.contact.telephonePowerTel' | translate }}" class="number">{{ 'module.contact.telephonePowerText' | translate }}</a>
      <div class="separator"></div>
      <div *ngIf="showGasDetails">
        <div class="label" *ngIf="gasLabel && gasLabel.length > 0">{{ gasLabel }}</div>
        <a href="tel:{{ 'module.contact.telephoneGasTel' | translate }}" class="number" *ngIf="gasNumber && gasNumber.length > 0">{{ gasNumber }}</a>
      </div>
      <div class="footer-description description" *ngIf="showContactFootnote">
        {{ 'module.contact.contactFootnoteText' | translate }}
      </div>
    </div>
  </div>
  <div class="footer-description description" *ngIf="showFooterText">Störungen können Sie rund um die Uhr bei uns melden.</div>
</div>
